import React from "react";
import { Container, Box } from "@mui/material";
import CustomAppBar from "../../components/AppBar";
import WeatherWidget from "../../components/WeatherWidget";
import QuickLinks from "../../components/QuickLinks";
import getQuickLinks from "../../Data/iconsData";

export default function ServiceProviderHomepage() {
  const quickLinksData = getQuickLinks("service_provider");

  return (
    <>
      <CustomAppBar />
      <Container maxWidth="xs" style={{ marginTop: 20 }}>
        <WeatherWidget />
        <Box mt={2}>
          <QuickLinks data={quickLinksData} />
        </Box>
      </Container>
    </>
  );
}
